import { useState, useEffect } from 'react';
import { isGroupChat } from '../Helpers/Chat/ChatHelper';
import { i18n } from '../localization/i18n';

const currentTypingData = (chatType, data, fromUserId) => {
    if (isGroupChat(chatType)) {
        const displayNames = data.filter(ele => ele.groupId && ele.groupId.indexOf(fromUserId) > -1 && ele.displayName);
        // Naming one of several typists would be arbitrary, so the group is described instead.
        if (displayNames.length > 1) return i18n.t('chat.preview.TYPING_SEVERAL');
        return displayNames.length && i18n.t('chat.preview.TYPING_USER', { name: displayNames[0]?.displayName });
    }

    const userTypingData = data.find(ele => ele.fromUserId.indexOf(fromUserId) > -1 && !ele.groupId);
    return userTypingData && i18n.t('chat.preview.TYPING');
};

/**
 * Get the user typing status
 * @param {*} param0
 */
export const useGetTypingStatus = ({ typingId, typingData, fromUserId, chatType }) => {
    const [messageTyping, setmessageTyping] = useState({
        isTyping: false,
        displayName: '',
    });

    useEffect(() => {
        if (typingId) {
            const displayName = currentTypingData(chatType, typingData, fromUserId);
            const isUserTyping = !!displayName;
            const { displayName: prevDisplayName, isTyping: prevIsTyping } = messageTyping;
            if (prevDisplayName === displayName && prevIsTyping) {
                return;
            }
            setmessageTyping({
                isTyping: isUserTyping,
                displayName,
            });
        }
    }, [fromUserId, typingId]);

    return messageTyping;
};
